import axios from 'axios';
import { delay, go, sel } from 'fxjs/es';
import { UtilS } from '../../../Util/S/Function/module/UtilS.js';

const iamport_code = 'imp03882726';
export const initIamport = () => {
  if (!window.IMP) return delay(300, 0).then(initIamport);
  IMP.init(iamport_code);
};

export const requestBilling = async ({ name, email }) => {
  if (!window.IMP) return;

  const { merchant_uid, customer_uid } = await go(axios.post(`/${T.lang}/@api/shopify/billing`), sel('data'));

  const payment_obj = {
    pg: 'html5_inicis.MOImarbill',
    pay_method: 'card',
    merchant_uid,
    customer_uid,
    name: '마플샵 제작비/배송비',
    amount: 0,
    buyer_email: email,
    buyer_name: name,
  };

  return new Promise((res, rej) => {
    IMP.request_pay(payment_obj, async (response) => {
      try {
        if (!response.success) return alert(`카드 등록이 실패했습니다. ${response.error_msg}`) || res(false);
        const approveBillingUrl = UtilS.makeApiUrl('/:lang/@api/shopify/billing/:merchant_uid', {
          lang: T.lang,
          merchant_uid,
        });
        await axios.put(approveBillingUrl);
        alert('결제 수단이 등록되었습니다.');
        res(true);
      } catch (err) {
        rej(err);
      }
    });
  });
};
